import Sidebar from './Sidebar';

export default Sidebar;



// WEBPACK FOOTER //
// ./src/containers/general/sidebar/index.js